import request from '@/utils/request'

// 注册渠道
export function xcChannelSign(data, token) {
    return request({
        url: 'cus/xcChannelSign',
        method: 'post',
        headers: {
            Token: token,
        },
        data
    })
}
// 发送验证码
export function sendSms(phone) {
    return request({
        url: 'cus/sendSms/' + phone,
        method: 'get'
    })
}

// 验证验证码
export function smsValid(phone, code) {
    return request({
        url: 'cus/smsValid/' + phone + '/' + code,
        method: 'get'
    })
}

// 登录
export function xcChannelLogin(data) {
    return request({
        url: 'cus/login/xcChannel',
        method: 'post',
        headers: {
            depName: data.depName,
        },
        data
    })
}

// 登录 使用验证码登录
export function loginBySms(data) {
    return request({
        url: 'cus/loginBySms/xcChannel',
        method: 'post',
        headers: {
            depName: data.depName,
        },
        data
    })
}

// 获取用户信息
export function getCurrentChannelInfo() {
    return request({
        url: 'api/getCurrentChannelInfo',
        method: 'get'
    })
}

// 设置渠道的token
export function updateChannelToken(data) {
    return request({
        url: 'api/updateChannelToken',
        method: 'post',
        data
    })
}

// 获取渠道的token
export function getChannelToken(data) {
    return request({
        url: 'cus/getChannelToken',
        method: 'post',
        data
    })
}

// 判断手机号是否已注册
export function isSign(phone) {
    return request({
        url: 'cus/user/isSign/' + phone ,
        method: 'get'
    })
}


// WEBPACK FOOTER //
// ./src/api/login.js